import { Instagram, Facebook } from "lucide-react";
import { SOCIALS } from "@/lib/brand";

const ICONS = { instagram: Instagram, facebook: Facebook };

export const FollowUs = ({ className = "" }) => (
  <div className={`flex items-center gap-4 ${className}`} data-testid="follow-us">
    <span className="text-[11px] font-mono uppercase tracking-[0.2em] text-muted-foreground">Follow us</span>
    <div className="flex items-center gap-2">
      {SOCIALS.filter((s) => ICONS[s.id]).map((s) => {
        const Icon = ICONS[s.id];
        return (
          <a
            key={s.id}
            href={s.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`follow-${s.id}`}
            aria-label={`Follow SBS Properties on ${s.label}`}
            title={`Follow us on ${s.label}`}
            className="flex h-9 w-9 items-center justify-center border hairline text-foreground/70 hover:text-ivory hover:bg-brand hover:border-brand transition-colors"
          >
            <Icon className="h-4 w-4" />
          </a>
        );
      })}
    </div>
  </div>
);
